export const changePermission = () => ({
    type: 'CHANGE_PERMISSION'
})



 